import { getClassName } from '../class-name';
export let BaseFeature = /*#__PURE__*/(() => {
  class BaseFeature {
    constructor(config) {
      this.config = config;
    }
    static {
      this.featureInfo = null;
    }
    resolveFeatureInfoFromStatic() {
      const info = this.constructor.featureInfo;
      if (!info) throw new Error('static featureInfo is invalid - ' + getClassName(this));
      return info;
    }
    getSharedDefinitionCached() {
      if (this.__featureFunctionalityCache) return this.__featureFunctionalityCache;
      this.__featureFunctionalityCache = this.getSharedDefinition();
      return this.__featureFunctionalityCache;
    }
  }
  return BaseFeature;
})();